/**
 * Flat key/value merge for the editor's working state. Pure; produces a
 * new top-level object without mutating either input. In PMM v4 the
 * working shape is flat -- `name` is just another key alongside the
 * properties, so there is no special-casing.
 *
 * Shallow merge: nested values (e.g. the `offlineSlates` / `breakSlates`
 * arrays) share references with `originalProperties` in the result.
 * Safe here because edit-side inputs emit new references for changed
 * keys; do not mutate nested values anywhere downstream.
 *
 * @param {Object<string, any>} originalProperties  flat properties from PlayerStore (post-`normalize`), plus `name`
 * @param {Object<string, any>} edits               flat partial of pending edits
 * @returns {Object<string, any>} new object: `originalProperties` overlaid with `edits`
 */
export function mergeEdits (originalProperties, edits) {
  return { ...originalProperties, ...edits };
}
